<template>
  <div class="recommendList">
    <H5ActivityView
      v-if="configInfo"
      :renderAgain="false"
      :options="configInfo"
      :serverDate="serverDate"
      :customWidgets="customWidgets">
      <LeaveMessage
        v-if="showComment"
        :id="configID"
        :isJudgePostion="true"/>
    </H5ActivityView>
  </div>
</template>

<script>
// 课程详情页推荐课程列表
import { H5ActivityView } from '@igetcool/cool-mobile-ui';
import LeaveMessage from '@/components/LeaveMessage';
import customWidgets from '../operateActivityV2/custom.config';
export default {
  name: '',
  props: {
    configInfo: {
      type: Object,
      required: true,
    },
    // 相当于是 activityId，用于对应上活动页
    configID: {
      type: String,
      required: true,
    }
  },
  components: {
    H5ActivityView,
    LeaveMessage,
  },
  data() {
    return {
      customWidgets,
    };
  },
  computed: {
    serverDate() {
      return this.configInfo.serverTimestamp;
    },
    showComment() {
      const { jsonInfo = {} } = this.configInfo;
      const { page = {} } = jsonInfo;
      const { comment = false } = page;
      return comment;
    },
  },
  methods: {},
  mounted() {},
};

</script>

<style scoped lang="stylus">
.recommendList {
  background-color #fff
}
</style>